var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11507 4.80078C4.49486 5.18937 4.49486 5.81011 4.11507 6.1987L1.2932 9.08597C1.13019 9.25275 1.13019 9.51917 1.2932 9.68595C1.46157 9.85822 1.73871 9.85822 1.90708 9.68595L5.7068 5.79818C5.86981 5.6314 5.86981 5.36498 5.7068 5.1982L5.40062 4.88492C5.4002 4.88449 5.39952 4.88449 5.3991 4.88492C5.39868 4.88535 5.398 4.88535 5.39758 4.88492L1.90761 1.31406C1.73924 1.14178 1.46209 1.14178 1.29372 1.31406C1.13072 1.48084 1.13072 1.74725 1.29372 1.91403L4.11507 4.80078Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeDelivery);
export default __webpack_public_path__ + "static/media/freeDelivery.00372eb9c25a799d202a12eb077c62ed.svg";
export { ForwardRef as ReactComponent };